import fetch from 'node-fetch';
import utils from "../../universal/utils";

export const FINANCE_LOADING = 'FINANCE_LOADING';
export const FINANCE_LOADED = 'FINANCE_LOADED';
export const FINANCE_ERROR = 'FINANCE_ERROR';
export const FINANCE_REFRESHING = 'FINANCE_REFRESHING';

const basePath = utils.getEdgeBasePath();

async function readJsonOrThrow(response) {
  if (!response.ok) {
    throw new Error(`HTTP ${response.status}: ${response.statusText}`);
  }

  const data = await response.json();
  if (!data.ok) {
    throw new Error(data.error || data.err || 'Finance request failed');
  }

  return data;
}

export const fetchFinanceSnapshot = ({ userId }) => {
  return async (dispatch) => {
    if (!userId) return;

    dispatch({ type: FINANCE_LOADING });

    try {
      const [overviewData, trendsData] = await Promise.all([
        fetch(`${basePath}/api/v7/admin/finance/overview/adpass/${userId}`).then(readJsonOrThrow),
        fetch(`${basePath}/api/v7/admin/finance/trends/adpass/${userId}`).then(readJsonOrThrow),
      ]);

      dispatch({
        type: FINANCE_LOADED,
        payload: {
          overview: overviewData.overview,
          charts: trendsData.charts,
          tables: trendsData.tables,
          freshness: overviewData.freshness || trendsData.freshness,
          fx: overviewData.fx || trendsData.fx,
        },
      });
    } catch (error) {
      console.error('Error fetching finance snapshot:', error);
      dispatch({
        type: FINANCE_ERROR,
        payload: error.message,
      });
    }
  };
};

export const refreshFinanceSnapshot = ({ userId }) => {
  return async (dispatch) => {
    if (!userId) return;

    dispatch({ type: FINANCE_REFRESHING });

    try {
      await fetch(`${basePath}/api/v7/admin/finance/refresh/adpass/${userId}`, {
        method: 'POST',
      }).then(readJsonOrThrow);

      return dispatch(fetchFinanceSnapshot({ userId }));
    } catch (error) {
      console.error('Error refreshing finance snapshot:', error);
      dispatch({
        type: FINANCE_ERROR,
        payload: error.message,
      });
    }
  };
};
